import colors from 'vuetify/lib/util/colors';

export default {
    light: {
        primary: '#112833',
        secondary: '#facda5',
        accent: "#476905",
        bg_main: "#ffffff",

        icons: {
            logo_flor: 'img/florecita.png',
            logo_tablet: 'img/tablet_logo.img',
            logo_header: 'img/logo_procu.png',
            logo_footer2: 'img/logo_footer2.svg',
            logo_footer: 'img/logo_footer_hidalgo.png',
            logo_navigation_postlogin: 'img/procu.png',
        },

        bg_footer: '#112833',
        bg_footer2: '#631132',
        bg_header: '#631132',

        // Tables
        title_table: '#98989A',
        bg_table_th: '#fff',
        txt_table_th: '#112833',

        // NavBar
        bg_navbar: '#112833',
        bg_navbar_: '#112833',
        txt_color_nav: '#ffffff',

        // Navigator drawers
        main_color: '#112833',
        main_color_action: '#42b549',
        main_color_itens: '#bc9855',

        botoncolorsegundo: '#42b549',

        // Dashboard cards
        bg_home_card_1: '#DDC9A3',
        bg_home_card_1_avatar: '#DDC9A3',
        bg_home_card_1_title: '#DDC9A3',

        bg_home_card_2: '#28a9e2',
        bg_home_card_2_avatar: '#239cd3',
        bg_home_card_2_title: '#50b7e4',

        bg_home_card_3: '#f0605f',
        bg_home_card_3_avatar: '#f34d4f',
        bg_home_card_3_title: '#ef7b7c',

        bg_home_card_4: '#8dc73f',
        bg_home_card_4_avatar: '#72bc41',
        bg_home_card_4_title: '#a1cf62',

        // Status
        status_active: '#000000',
        status_process: '#f1c232',
        status_canceled: colors.pink.darken1,
        status_finished: '#72bc41',

        error: colors.red.lighten1,
        warning: colors.orange.lighten1,
    },

    // 🔥 Bloque separado — NO genera warnings
    texts: {
        title_login: "Procuraduría General de Justicia del Estado de Hidalgo",
        subtitle_login: "Plataforma de acceso a los tramites y servicios",
    }
};